"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _default = exports.default = {
  SVG: _styledComponents.default.svg`
    ${function (_ref) {
    let {
      fill
    } = _ref;
    return fill && `fill: ${fill}`;
  }};
  `,
  Image: _styledComponents.default.img`
    width: ${function (_ref2) {
    let {
      width = "100%"
    } = _ref2;
    return width;
  }};
    display: inline-block;
    ${function (_ref3) {
    let {
      fill
    } = _ref3;
    return ["#FFF", "#FFFFFF", "white"].findIndex(function (i) {
      return i === fill;
    }) > -1 && "filter: invert(1);";
  }}
  `,
  IconContainer: _styledComponents.default.span`
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 100%;
      fill: ${function (_ref4) {
    let {
      fill
    } = _ref4;
    return fill || `var(--app-primary-text-color, #000)`;
  }};
    }
  `
};